<modal-header title="Confirm {{currentUser.person.email}}"></modal-header>
<ion-content [formGroup]="formGroup">
    <ion-item>
        <ion-label position="floating">Confirmation Code</ion-label>
        <ion-input name="code" formControlName="code" required maxlength="6" #firstInput></ion-input>
    </ion-item>
    <ion-item lines="none">
        <a (click)="resend()">Resend confirmation email</a>
    </ion-item>
</ion-content>


<ion-footer class="ion-no-border">
    <ion-grid class="footer-button-grid">
        <ion-row>
            <ion-col size-xs="6">
                <ion-button color="dark" class="full-footer-button" (click)="close('CANCEL')">
                    Cancel
                </ion-button>
            </ion-col>

            <ion-col size-xs="6">
                <ion-button color="dark" class="full-footer-button" [disabled]="formGroup.invalid" (click)="submit()">
                    Save
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-footer>
